import React, {Fragment} from 'react';
import {hasCellComments} from '../analyticsUtils';

export default function ScoreCell({
  cellKey,
  question,
  response,
  report,
  popupPosition,
  setPopupPosition,
  getBackgroundColor,
  getCellColor,
  getCellValue,
  renderCommentPopup,
}) {
  if (!response) {
    return (
      <div className="score">
        N/R
      </div>
    )
  }

  return (
    <div
      className="score"
      title={hasCellComments(response) && popupPosition[cellKey] ? null : question}
      key={question}
      onMouseEnter={(e) => setPopupPosition(cellKey, e)}
      style={{
        backgroundColor: getBackgroundColor(response, report.settings.scale),
        color: getCellColor(response)
      }}
    >
      {getCellValue(response, report)}

      {hasCellComments(response)
      && <span className="has-comment">
          <i className="fa fa-comment"/>
        </span>
      }
      {hasCellComments(response)
      && popupPosition[cellKey] &&
      <Fragment>
        {renderCommentPopup(
          response,
          question,
          popupPosition[cellKey]
        )}
      </Fragment>
      }
    </div>
  )
}
